module.exports = __webpack_public_path__ + "static/media/backpack-logo.adeeea36.svg";